import { createController, prepActions } from "~/hocs/crud";
import { service } from "./service";

const actions = prepActions(service);
const setReportBookOptionsSaga = createController(service, actions);

export { actions, setReportBookOptionsSaga };
